module.exports = __webpack_public_path__ + "static/media/P2_S3_1.5bb0f576.png";